export default {
  API_DIMOCO: 'dimoco',
  API_LANCIO: 'lancio',
  API_GO4MOBILITY: 'g4m',
  API_MESSAGECLOUD: 'messagecloud',
  API_MGAGE: 'mgage',
  API_MACROKIOSK: 'macrokiosk',
  API_NTH: 'nth',
  API_TPAY: 'tpay',
  DEV_SERVER: 'http://localhost:9001',
  DEFAULT_SERVER: '',
  GR_SERVER: 'http://gr.muscle-heroes.com'
}


// WEBPACK FOOTER //
// ./src/constants.js